<template>
  <div>
    <Table :data="tableData" :options="listDataOptions" align="center"></Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
      :pageSizes="[10, 15, 25, 50]"
    ></Pagination>
  </div>
</template>
<script>
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins';
import Pagination from '@/components/layouts/Pagination';
import { preservationgetDetail ,  getTbalNation,} from '@/api/securityManage';
export default {
  props: {
    preservationId: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [myMixin],
  components: {
    Table,
    Pagination,
  },
  watch: {
    preservationId: {
      deep: true,
      immediate: true,
      handler(newval, oldval) {
        if (newval) {
          this.queryData();
        }
      },
    },
  },
  data() {
    return {
      dicArr: [
        'gen.identityType',
        'gen.gender',
        'gcbs.rela.with.staff',
        'gcbs.occupation.type',
        'gcbs.social.insurance',
        'gen.identityType',        
      ],
      tableData: [],
      listDataOptions: [
        {
          prop: 'insuredName',
          label: '被保人姓名',
        },
        {
          prop: 'insuredCardType',
          label: '证件类型',
          dic: 'gen.identityType',
        },
        {
          prop: 'insuredCardNo',
          label: '证件号码',
        },
        {
          prop: 'gender',
          label: '性别',
          dic: 'gen.gender',
        },
        {
          prop: 'birthday',
          label: '出生日期',
        },
        {
          prop: 'relaWithStaff',
          label: '与员工关系',
          dic: 'gcbs.rela.with.staff',
        },
        {
          prop: 'planName',
          label: '保险计划',
        },
        {
          prop: 'occupationType',
          label: '职业类别',
          dic: 'gcbs.occupation.type',
        },
        {
          prop: 'socialSecurity',
          label: '医保标识',
          dic: 'gcbs.social.insurance',
        },
        {
          prop: 'insuredPhoneNo',
          label: '移动电话',
        },
        {
          prop: 'nation',
          label: '国籍/地区',
        },

        {
          prop: 'passNo',
          label: '来往内地通行证号码',
        },
        {
          prop: 'subInsuredCardType',
          label: '主被保险人证件类型',
          dic: 'gen.identityType',
        },
        {
          prop: 'subInsuredCardNo',
          label: '主被保险人证件号码',
        },
        {
          prop: 'effectiveTime',
          label: '生效日期',
        },
      ],
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          preservationId: '',
          preservationType: '01',
        },
      },
      total: 0,
      nationOptions:[],
    };
  },
  methods: {
    async nationInit(){
        let res=await getTbalNation({})
        if(res&&Array.isArray(res)){
            this.nationOptions=res
        }
        },
    init() {
      this.nationInit()
    },
    async queryData(bool = true) {
      // 默认将当前页数归1
      if (bool) this.initParam.pageNum = 1;
      this.initParam.param.preservationId = this.preservationId;

      this.initParam.param.policyId = this.info.policyId;
      this.initParam.param.preservationSource = this.info.preservationSource;
      let res = await preservationgetDetail(this.initParam);
      if (res && Array.isArray(res.list)) {
        // 将国籍code转换成名称
        this.tableData = res.list.map(item=>{
          let Tvalue=this.nationOptions.find(ele=>ele.key===item.nation)
         item.nation= Tvalue?Tvalue.value:'中国'
         return item
        });
        this.total = res.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
</style>